export default "__VITE_ASSET__05b2e5de__"